/** *************************************************************
 * Copyright (c) 2006 - 2020, Case Anywhere, LLC.
 * All rights reserved
 *
 * @author Brad Wetmore
 * Date: 01/15/2021
 *
 * @version 0.1
 * Revisions:
 * 01/15/2021 - BW - Initial Creation
 *
 * Description/Purpose:
 * Payment - Auth.net - Transact Response Bill To DTO
 ************************************************************** */

export default class PaymentAuthNetTransactResponseBillToDTO {
  constructor(obj) {
    if (obj) Object.assign(this, obj);
  }

  get firstName() {
    return this._firstName;
  }

  set firstName(value) {
    this._firstName = value;
  }

  get firstlastName() {
    return this._firstlastName;
  }

  set firstlastName(value) {
    this._firstlastName = value;
  }

  get address() {
    return this._address;
  }

  set address(value) {
    this._address = value;
  }

  get city() {
    return this._city;
  }

  set city(value) {
    this._city = value;
  }

  get state() {
    return this._state;
  }

  set state(value) {
    this._state = value;
  }

  get zip() {
    return this._zip;
  }

  set zip(value) {
    this._zip = value;
  }

  get country() {
    return this._country;
  }

  set country(value) {
    this._country = value;
  }

  get phoneNumber() {
    return this._phoneNumber;
  }

  set phoneNumber(value) {
    this._phoneNumber = value;
  }
}
